import All from './filters/All';
import Custom from './filters/Custom';
import Dates from './filters/Dates';
import DeparturePort from './filters/DeparturePort';
import Destinations from './filters/Destinations';
import Nights from './filters/Nights';
import NumberOfGuests from './filters/NumberOfGuests';
import SelectQualifiers from './filters/Qualifiers';
import Ships from './filters/Ships';

import AllFiltersButton from 'components/buttons/AllFiltersButton';
import FilterDropdown from 'components/buttons/FilterDropdown';

const filtersMap = {
	all: {
		key: 'all',
		label: 'All Filters',
		showSearchBar: false,
		component: All,
		ButtonComponent: AllFiltersButton,
		labelKey: 'actionAllFilters',
		dataTestId: 'all-filter-button',
	},
	startDate: {
		key: 'startDate',
		label: 'Cruise dates',
		showSearchBar: false,
		component: Dates,
		ButtonComponent: FilterDropdown,
		labelKey: 'navCruiseDates',
		dataTestId: 'date-filter-button',
	},
	destination: {
		key: 'destination',
		label: 'Destinations',
		showSearchBar: true,
		component: Destinations,
		ButtonComponent: FilterDropdown,
		labelKey: 'navDestination',
		dataTestId: 'destination-filter-button',
	},
	departurePort: {
		key: 'departurePort',
		label: 'Departure port',
		showSearchBar: true,
		component: DeparturePort,
		ButtonComponent: FilterDropdown,
		labelKey: 'navDeparturePort',
		dataTestId: 'departure-port-filter-button',
	},
	nights: {
		key: 'nights',
		label: 'Number of nights',
		showSearchBar: true,
		component: Nights,
		ButtonComponent: FilterDropdown,
		labelKey: 'navNights',
		dataTestId: 'number-of-nights-filter-button',
	},
	numberOfGuests: {
		key: 'numberOfGuests',
		label: 'Number of guests',
		showSearchBar: false,
		component: NumberOfGuests,
		ButtonComponent: FilterDropdown,
		labelKey: 'navNumberOfGuests',
		dataTestId: 'number-of-guests-filter-button',
	},
	ship: {
		key: 'ship',
		label: 'Ships',
		showSearchBar: true,
		component: Ships,
		ButtonComponent: FilterDropdown,
		labelKey: 'navShips',
		dataTestId: 'ship-filter-button',
	},
	custom: {
		key: 'custom',
		label: 'custom',
		showSearchBar: false,
		component: Custom,
		ButtonComponent: FilterDropdown,
		labelKey: 'navSpecialSailings',
		dataTestId: 'custom-filter-button',
	},
	qualifiers: {
		key: 'qualifiers',
		label: 'My Offers',
		showSearchBar: false,
		component: SelectQualifiers,
		ButtonComponent: FilterDropdown,
		labelKey: 'navMyOffers',
		dataTestId: 'my-offers-filter-button',
	},
};

export default filtersMap;
